<script>
import Page2D from '@/components/Page2D'
import { useI18n } from 'vue-i18n'

export default {
  name: 'NotFoundPage',
  
  components: {
    Page2D
  },
  setup() {
    const { t } = useI18n()
    return { t }
  }
};
</script>

<template>
  <Page2D :title="t('notFoundPage.title')">
    {{t('notFoundPage.labels.notFound')}}
  </Page2D>
</template>
